import React, { useContext } from 'react';
import { useQuestionnaireModal } from '../../../../utils/questionnaire_modal_context';
import { useHistory } from 'react-router-dom';
import { redirectAfterSurgery } from '../../../../helpers/redirect_after_surgery_helper.js';

import GatewayModal, { appModalStyles } from '../gateway_modal';
import Context from '../../../../utils/context';

const QuestionnaireModal = ({}) => {
  const context = useContext(Context);
  const history = useHistory();
  const { isModalVisible } = useQuestionnaireModal();

  if (!isModalVisible) return null;

  const handleRedirectToQuestionnaire = () => {
    context.auth.userUpdate({ aborted_questionnaire: new Date() }, (user) => {
      if (user.matched_with_mentor) {
        history.push('/member/conversations');
        return;
      }

      const match = user.current_profile.mentor_match;
      redirectAfterSurgery(history, match, user.account);
    });
  };

  return (
    <GatewayModal
      title="You're almost there!"
      content={
        <p>Finish your questionnaire to chat with a real patient or caregiver and learn from their experience.</p>
      }
      footer={
        <button type='button' className={appModalStyles.primary_btn} onClick={handleRedirectToQuestionnaire}>
          Find My Mentor
        </button>
      }
    />
  );
};

export default QuestionnaireModal;
